var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m104.57,64.46c0,.35-.17.61-.44.79l-13.77,11.94c-.52.35-1.23.35-1.66-.17l-8.46-9.77v42.19c0,.62-.52,1.14-1.13,1.14h-22.06c-.61,0-1.13-.52-1.13-1.14v-42.19l-8.46,9.77c-.44.52-1.14.52-1.58.17l-14.38-11.33c-.27-.17-.35-.44-.44-.79,0-.34.08-.61.35-.87l35.74-40.28c.27-.25.53-.44.87-.44s.7.18.87.44l35.4,39.67c.18.27.27.52.27.87Z",
    style: {
      fill: "#064860",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "135.13 1.99 135.13 134.01 76.38 134.01 76.38 118.74 119.75 118.74 119.75 17.26 76.38 17.26 76.38 1.99 135.13 1.99",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.25 1.99 60.25 17.26 17.85 17.26 17.85 118.74 60.25 118.74 60.25 134.01 1.87 134.01 1.87 1.99 60.25 1.99",
    style: {
      fill: "#d65e38"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.3010ad663bb22dcc4153e3b4607c33f8.svg";
export { ForwardRef as ReactComponent };